"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasketOutlined = void 0;
var react_1 = __importStar(require("react"));
var BaseIcon_1 = require("../icon/BaseIcon");
exports.BasketOutlined = (0, react_1.memo)(function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'medium' : _b, title = _a.title, className = _a.className, dataTestId = _a.dataTestId;
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, { className: className, dataTestId: dataTestId, size: size, title: title },
        size === 'large' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "m10.375 9.24997v3.62513h-5.625l5.615 13.125h11.2299l5.6551-13.125h-5.6191v-3.6251h-.0069c-.0559-3.18557-2.5525-5.75-5.624-5.75s-5.569 2.56444-5.625 5.74997zm5.625-3.74997c1.9259 0 3.625 1.65022 3.625 3.85943h.0059v3.51567h-7.2559v-3.51573c0-2.2092 1.6991-3.85937 3.625-3.85937zm-4.3153 18.5001-3.90375-9.125h16.42955l-3.9316 9.125z", fillRule: "evenodd" })),
        size === 'medium' && (react_1.default.createElement("path", { clipRule: "evenodd", d: "m7.5 9.50003h-4.5l4.49198 10.49997h8.98392l4.5241-10.49997h-4.5v-2.90005c-.0448-2.54845-2.0428-4.59998-4.5-4.59998s-4.45441 2.05155-4.49923 4.59998l-.00077.08756zm7.5-2.81249c0-1.8187-1.4003-3.18754-3-3.18754s-3 1.36879-3 3.1875v2.81253h6zm-6.51823 11.81246-3.20856-7.5h13.44719l-3.2315 7.5z", fillRule: "evenodd" }))));
});
exports.BasketOutlined.displayName = 'BasketOutlined';
//# sourceMappingURL=BasketOutlined.js.map